<script setup lang="ts">
import type { Kennel } from '@/modules/Entities/Shelter/modules/KennelManager/types/kennel.types';
import { computed } from 'vue';
import { useSessionStore } from '@Stores';
import { useADialog } from '@Atoms';
import { getTruncatedText } from '@Helpers';
import { ROLES } from '@AuthModule';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const { can } = useSessionStore();

const { activeModal, activeModalProps, dialogVisibility } = useADialog();

const canEdit = computed(() => can(ROLES.EDIT_ANIMAL) || can(ROLES.KENNEL_MANAGER_SETTINGS));
const animalStatus = computed(() => props.rowData[props.settings?.render?.animalStatusKey]);
const itemId = computed(() => props.field?.$oid || props.field);
const inCareAnimal = computed(() => animalStatus.value === 'in_care');

function openModal() {
  activeModalProps.value = {
    ...props.settings.render.modalProps,
    rowData: props.rowData,
  };
  activeModal.value = props.settings.render.activeModal;
  dialogVisibility.value = true;
}

function filterEntity(id: string, level: string) {
  const kennelManagerList = props.settings.kennelManagerLevelsLabels[level];
  const entity = kennelManagerList.find((_entity: Kennel) => _entity._id === id);
  return entity?.label || '-';
}
</script>

<template>
  <div
    :class="[canEdit && inCareAnimal ? 'cursor-pointer' : '']"
    @click="canEdit && inCareAnimal ? openModal() : null"
  >
    <span
      v-if="!field"
      class="flex flex-col items-start gap-0.5"
    >
      -
    </span>

    <p
      v-else-if="settings.isSite"
      v-tooltip.top="filterEntity(itemId, 'sites')"
      class="w-fit"
    >
      {{ getTruncatedText(filterEntity(itemId, 'sites'), 15) }}
    </p>

    <p
      v-else-if="settings.isBuilding"
      v-tooltip.top="filterEntity(itemId, 'buildings')"
      class="w-fit"
    >
      {{ getTruncatedText(filterEntity(itemId, 'buildings'), 15) }}
    </p>

    <p
      v-else-if="settings.isLocation"
      v-tooltip.top="filterEntity(itemId, 'locations')"
      class="w-fit"
    >
      {{ getTruncatedText(filterEntity(itemId, 'locations'), 15) }}
    </p>

    <p
      v-else
      v-tooltip.top="filterEntity(itemId, 'kennels')"
      class="w-fit"
    >
      {{ getTruncatedText(filterEntity(itemId, 'kennels'), 15) }}
    </p>
  </div>
</template>
